import React, { Component } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
} from "recharts";

import themeLarge from "../../component/ThemeLarge";

class MetricDistributionChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMetric: "LCP",
      thresholds: {
        LCP: [2500, 4000], // <2500 good, <4000 needs improvement
        FID: [100, 300], // <100 good, <300 NI
        INP: [200, 500],
        CLS: [0.1, 0.25],
        TTFB: [600, 1200],
        FCP: [1800, 3000],
      },
    };
  }

  categorize = (metric, value) => {
    const [goodMax, midMax] = this.state.thresholds[metric] || [
      Infinity,
      Infinity,
    ];
    if (value <= goodMax) return "Good";
    if (value <= midMax) return "Needs Improvement";
    return "Poor";
  };

  computeDistribution = () => {
    const { selectedMetric } = this.state;
    const entries = this.props.groupedMetrics[selectedMetric] || [];

    const buckets = {
      Good: 0,
      "Needs Improvement": 0,
      Poor: 0,
    };

    entries.forEach((e) => {
      const val = Number(e.value);
      const label = this.categorize(selectedMetric, val);
      buckets[label]++;
    });

    return [
      { category: "Good", count: buckets.Good },
      { category: "Needs Improvement", count: buckets["Needs Improvement"] },
      { category: "Poor", count: buckets.Poor },
    ];
  };

  handleMetricChange = (e) => {
    this.setState({ selectedMetric: e.target.value });
  };

  render() {
    const { selectedMetric } = this.state;
    const data = this.computeDistribution();

    return (
      <div className="mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 style={{ color: themeLarge.colors.primary }}>
            {selectedMetric} Distribution
          </h5>
          <select
            value={selectedMetric}
            onChange={this.handleMetricChange}
            className="form-select form-select-sm"
            style={{ width: "160px" }}
          >
            {Object.keys(this.props.groupedMetrics).map((metric) => (
              <option key={metric} value={metric}>
                {metric}
              </option>
            ))}
          </select>
        </div>

        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="category" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Legend />
            <Bar
              dataKey="count"
              name="Sessions"
              fill={themeLarge.colors.primary}
              label={{ position: "top" }}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

export default MetricDistributionChart;
